module.exports = __webpack_public_path__ + "static/media/seven.b6e8f92a.jpg";